/**
 * en-GB messages added by Phase 3 task S34 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s34EnGB = {
    'error.nfc_uid_invalid': 'That card number is not valid. Use 4, 7 or 10 bytes of hex, for example 04:A2:2B:1C.',
    'error.nfc_card_limit': 'This person already has the most cards allowed.',
    'error.nfc_card_state': 'This card cannot be changed in its current state.',
    'error.nfc_card_stolen': 'A stolen card cannot be unblocked. Retire it instead.',
    'error.nfc_members_invalid': 'Choose current members only.',
    'error.nfc_import_unreadable': 'That file could not be read as a CSV.',
    'error.nfc_import_too_many': 'That file has too many rows. Split it into smaller files.',
    'nfc.import.invalid_uid': 'The card number is not valid.',
    'nfc.import.duplicate_in_file': 'This card number appears earlier in the file.',
    'nfc.import.member_not_found': 'No current member matches this email or id.',
    'nfc.import.member_ambiguous': 'More than one member has this email. Use the member id.',
    'nfc.import.in_use': 'This card is already registered.',
    'nfc.import.limit': 'This person already has the most cards allowed.',
};
//# sourceMappingURL=s34.js.map